import Spinner from "react-bootstrap/Spinner";

interface LoadingOverlayProps {
  show: boolean;
  message?: string;
  fullScreen?: boolean;
  zIndex?: number;
}

const LoadingOverlay = ({ 
  show, 
  message = "Loading...", 
  fullScreen = false,
  zIndex
}: LoadingOverlayProps) => {
  if (!show) return null;

  const defaultZIndex = fullScreen ? 9999 : 10;
  const backgroundColor = fullScreen ? "rgba(255, 255, 255, 0.95)" : "rgba(255, 255, 255, 0.9)";

  return (
    <div
      style={{
        position: fullScreen ? "fixed" : "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: backgroundColor,
        zIndex: zIndex || defaultZIndex,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Spinner animation="border" variant="warning" style={{ width: "3rem", height: "3rem" }} />
      <div className="mt-3">
        <h5 className="text-muted">{message}</h5>
      </div>
    </div>
  );
};

export default LoadingOverlay;